import React from 'react'
import clsx from 'clsx'
import { ICONS } from '@Const/common'
import Button from '@Components/Buttons/Button'

interface SearchInputProps {
    id: string
    placeholder: string
    onClearInput(): void
    buttonClick(value: string): void
    onChangeInput?: (value: string, id: string) => void
    value?: string
    searchDisabled?: boolean
    searchFieldClicked?: () => void
}

const SearchInput = ({
    value = '',
    onChangeInput,
    id,
    placeholder,
    buttonClick,
    searchFieldClicked,
    onClearInput,
    searchDisabled,
}: SearchInputProps) => {
    const [inputValue, setInputValue] = React.useState(value)

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const newValue = event.target.value
        setInputValue(newValue)
        if (onChangeInput) {
            onChangeInput(newValue, id)
        }
    }

    const clickButton = () => {
        buttonClick(inputValue)
    }

    const cleanChange = () => {
        setInputValue('')
        onClearInput()
    }

    const onKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === 'Enter') {
            clickButton()
        }
    }

    const classNames = clsx('search-field-component', 'main-color-set', inputValue && 'filled')

    return (
        // I left data-testid with old name for backward compatibility with tests
        <div className={classNames} data-testid={'search-with-filter-' + id}>
            <div className="input-wrapper">
                <input
                    type="text"
                    id={id}
                    value={inputValue}
                    placeholder={placeholder}
                    onChange={handleChange}
                    disabled={searchDisabled}
                    onClick={searchFieldClicked}
                    onKeyDown={onKeyDown}
                />
                {inputValue && <img onClick={cleanChange} className="remove-value" src={ICONS.close} alt="close" />}
                <Button
                    onlyIcon
                    mainColor
                    type="primary"
                    icon={ICONS.search}
                    disabled={searchDisabled}
                    iconAltText="Search Works"
                    onClick={clickButton}
                />
            </div>
        </div>
    )
}

export default SearchInput
